<template>
  <div class="dashboard-fault-count-dialog">
    <custom-dialog width="80%" :title="model.title" :visible="visible"  v-on="$listeners">
      <div class="dialog-body">
        <div class="search-hd">
          <el-form :inline="true" @submit.native.prevent class="filter-form">
            <el-form-item >
              <el-radio-group v-model="tab" @change="getTableList()">
                <el-radio-button :label="item.value" v-for="(item, index) in tabData" :key="index">{{ item.label }}</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item style="float: right; margin-right: 0">
              <el-button
                class="table-set"
                style="vertical-align: top"
                @click.native="exportTable(exportApi, {...formSearch,excludeColumnList:filterArr})"
              ><i class="icon icon-daochu"></i></el-button>
            </el-form-item>
            <el-form-item style="float: right">
              <search-input v-model="formSearch.machineVersion" :placeholder="$t('base_dashboard_fault_count_dialog.ji_qi_ban_ben')" @fetch="onDateChange" style="width: 200px;"></search-input>
            </el-form-item>
            <el-form-item style="float: right">
              <!-- 部件编码  -->
              <search-input v-model="formSearch.search" :placeholder="$t('base_dashboard_fault_count_dialog.ji_shen_hao')" @fetch="onDateChange" style="width: 200px;"></search-input>
            </el-form-item>
                        <el-form-item  style="float: right">
              <custom-date-picker
                v-model="formSearch.dateTimes"
                type="daterange"
                align="right"
                unlink-panels
                :start-placeholder="$t('base_dashboard_fault_count_dialog.kai_shi_ri_qi')"
                :end-placeholder="$t('base_dashboard_fault_count_dialog.jie_shu_ri_qi')"
                style="width: 340px"
                :picker-options="pickerOptions"
                @change="onDateChange"
              ></custom-date-picker>
            </el-form-item>

          </el-form>
        </div>
        <!-- 表格 -->
        <div class="product-wrap">
          <div class="table-bd">
            <custom-table
              index
              ref="table"
              :data="tableList"
              :loading="isLoading"
              table-code="dashboard_fault_count"
              @filter="filterChange"
              @sort="sortChange"
              :slots="['bodyNum', 'action']"
              :filterArr="filterArr"
              height="680px"
            >
              <template slot="bodyNum" slot-scope="scope">
                <template>
                  <div class="cell-link" @click="onDeviceDetail(scope.row.bodyNum)">{{ scope.row.bodyNum }}</div>
                </template>
              </template>
              <template slot="action" slot-scope="scope">
                <!-- unUploadRecord: '未上传清洁记录',暂时缺跳转 -->
                <el-button v-if="model.type !== 'unUploadRecord'" type="text" size="mini" @click="onShowDetail(scope.row)">{{ $t('Common.com_detail') }}</el-button>
              </template>
            </custom-table>
          </div>
          <div class="table-page">
            <div class="table-sum-params" v-if="tableList.length > 0">
              <div class="sum-item ml-10">
                <div class="key">{{ $t('base_dashboard_fault_count_dialog.shi_jian_shu') }}：</div>
                <div class="val selected-num">{{ eventTotal }}</div>
              </div>
              <div class="sum-item ml-10">
                <div class="key">{{ $t('base_dashboard_fault_count_dialog.ji_qi_shu') }}：</div>
                <div class="val selected-num">{{ deviceTotal }}</div>
              </div>
            </div>
            <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">{{
         $t('Common.com_close')
        }}</el-button>

      </div>
    </custom-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';
import moment from 'moment';

export default {
  mixins: [dialogMixins],
  computed: {
    tabData() {
      return [
        {
          label: this.$t('base_dashboard_fault_count_dialog.ji_qi_tong_ji'),
          value: '0',
        },
        {
          label: this.$t('base_dashboard_fault_count_dialog.ri_qi_tong_ji'),
          value: '1',
        },
        {
          label: this.$t('Common.com_details'),
          value: '2',
        },
      ];
    },
    requestApi() {
      const api = {
        '0': apis.eventRankingDeviceStatistics,
        '1': apis.eventRankingDateStatistics,
        '2': apis.eventRankingList,
      };
      return api[this.tab];
    },
    exportApi() {
      const api = {
        '0': 'eventRankingDeviceStatisticsExport',
        '1': 'eventRankingDateStatisticsExport',
        '2': 'eventRankingListExport',
      };
      return api[this.tab];
    },
    filterArr() {
      if (this.tab === '0') {
        return ['eventTime', 'time'];
      } else if (this.tab === '1') {
        return ['eventTime'];
      } else {
        return ['time', 'eventCount'];
      }
    },
    pickerOptions() {
      const now = moment(this.$getLocalTime()); // 获取当前时间
      const minDateLocal = now.clone().subtract(30, 'days'); // 当前时间前30天
      const maxDateLocal = now; // 当前时间

      return {
        firstDayOfWeek: 1,
        disabledDate(time) {
          const momentTime = moment(time);
          // 禁用当前时间之后的日期
          return momentTime.isBefore(minDateLocal, 'day') || momentTime.isAfter(maxDateLocal, 'day');
        }
      };
    }

  },
  data() {
    return {
      tab: '0',
      formSearch: {
        pageSize: 30,
        pageNum: 1,
        search: '',
        machineVersion: '',
        productCode: '',
        componentCode: '',
        eventType: '',
        eventCode: '',
        dataType: '',
        customerId: '',
        agentCoId: '',
        afterServiceId: '',
        locationId: '',
        beginTime: '',
        endTime: '',
        // beginTime: '2024-12-14 00:00:00',
        // endTime: '2025-04-24 00:00:00',
        dateTimes: [],
        maxdateTimes: [],
      },

      tableList: [],
      totalRows: null,
      isLoading: false,
      deviceTotal: undefined,
      eventTotal: undefined,

    };
  },
  mounted() {

    this.initDialog();
    // this.dateTimes = this.model.data.dateTimes;
    // this.maxdateTimes = this.model.data.maxdateTimes;
    if (this.model.formSearch) {
      this.formSearch = this.model.formSearch;
    } else {
      this.$setFormatData(this.formSearch, this.model.data);
    }
    this.getTableList();
    this.getTableCount();
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.$nextTick(() => {
        this.visible = true;
      });
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },
    // 获取列表
    getTableList: function () {
      // this.isLoading = true;
      this.formSearch.beginTime = this.formSearch.dateTimes ? this.formSearch.dateTimes[0] : '';
      this.formSearch.endTime = this.formSearch.dateTimes ? this.formSearch.dateTimes[1] : '';
      this.$getJSON(this.requestApi, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    getTableCount() {
      this.$getJSON(apis.eventRankingTotal, this.formSearch).then((res) => {
        this.deviceTotal = res.data.deviceTotal;
        this.eventTotal = res.data.eventTotal;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    onDeviceDetail(bodyNum) {
      this.jump('/devicedetail', { bodyNum: bodyNum, parentPath: this.$route.path }, null, true);
      this.$emit('openBack', this.formSearch);
      this.closeDialog();
    },
    onDateChange() {
      this.onPageChange({ page: 1 });
      this.getTableCount();
    }

  },
};
</script>

<style lang="scss">
.dashboard-fault-count-dialog {

  .table-sum-params {
    float: left;
    overflow: hidden;

    .selected-num {
      padding: 0 5px;
      color: #0d9ae0;
    }

    .sum,
    .price {
      color: #0d9ae0;
    }

    .ml-10 {
      margin-left: 10px;
    }

    .sum-item {
      float: left;
      line-height: 32px;
      font-size: 12px;
      color: #606266;

      .key,
      .val {
        float: left;
      }
    }
  }
}
</style>
